var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { Alert, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { RecommendationModule } from "../../../models/profile/smartData.model";
import { SectorType } from "../../../models/sector/sector.model";
import { ProfileAiService } from "../../../services/profile/profileAi.service";
import { formatDateDMYHM } from "../../../utils/date.util";
var ProfileRecommendations = function (_a) {
    var _b, _c, _d, _e, _f, _g, _h, _j, _k;
    var profile = _a.profile, setProfile = _a.setProfile, sector = _a.sector;
    var _l = useTranslation(), t = _l.t, i18n = _l.i18n;
    var spaRecommendations = (_d = (_c = (_b = profile.smartData) === null || _b === void 0 ? void 0 : _b.recommendations) === null || _c === void 0 ? void 0 : _c.filter(function (r) { return r.recommendationModule === RecommendationModule.SPA_MODULE; })) !== null && _d !== void 0 ? _d : [];
    var restaurantRecommendations = (_g = (_f = (_e = profile.smartData) === null || _e === void 0 ? void 0 : _e.recommendations) === null || _f === void 0 ? void 0 : _f.filter(function (r) { return r.recommendationModule === RecommendationModule.RESTAURANT_MODULE; })) !== null && _g !== void 0 ? _g : [];
    var recommendations = [];
    if ((sector === null || sector === void 0 ? void 0 : sector.sectorType) === SectorType.SPA) {
        recommendations = spaRecommendations;
    }
    else if ((sector === null || sector === void 0 ? void 0 : sector.sectorType) === SectorType.RESTAURANT) {
        recommendations = restaurantRecommendations;
    }
    else {
        // dailylist does not have a module assigned to it
        recommendations = (_k = (_j = (_h = profile.smartData) === null || _h === void 0 ? void 0 : _h.recommendations) === null || _j === void 0 ? void 0 : _j.filter(function (r) { return !r.recommendationModule; })) !== null && _k !== void 0 ? _k : [];
    }
    if (!recommendations.length)
        return null;
    var dates = recommendations
        .map(function (r) { return r.date; })
        .filter(function (d) { return !!d; })
        .map(function (d) { return new Date(d); });
    var latestDate = dates.sort(function (a, b) { return b.getTime() - a.getTime(); })[0];
    var handleDeleteRecommendation = function (rec) { return __awaiter(void 0, void 0, void 0, function () {
        var removed, filtered, e_1;
        var _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    _d.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, ProfileAiService.removeRecommendation(profile.id, rec)];
                case 1:
                    removed = _d.sent();
                    if (!removed)
                        return [2 /*return*/];
                    filtered = (_c = (_b = (_a = profile.smartData) === null || _a === void 0 ? void 0 : _a.recommendations) === null || _b === void 0 ? void 0 : _b.filter(function (r) {
                        return !(r.severity === rec.severity &&
                            JSON.stringify(r.localizations) === JSON.stringify(rec.localizations));
                    })) !== null && _c !== void 0 ? _c : [];
                    setProfile(__assign(__assign({}, profile), { smartData: __assign(__assign({}, profile.smartData), { recommendations: filtered }) }));
                    return [3 /*break*/, 3];
                case 2:
                    e_1 = _d.sent();
                    console.error("Failed to remove recommendation", e_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
    return (_jsxs(Stack, __assign({ gap: 1 }, { children: [_jsxs(Typography, __assign({ variant: "subtitle1", fontWeight: 500, mt: 1 }, { children: [t("AI Recommendations"), " (", t("last updated"), ": ", formatDateDMYHM(latestDate), ")"] })), recommendations.map(function (rec, index) {
                var _a, _b;
                var message = ((_a = rec.localizations) === null || _a === void 0 ? void 0 : _a[i18n.language]) ||
                    ((_b = rec.localizations) === null || _b === void 0 ? void 0 : _b["en"]) ||
                    Object.values(rec.localizations || {})[0] ||
                    "";
                return (_jsx(Alert, __assign({ severity: rec.severity === "WARNING"
                        ? "warning"
                        : rec.severity === "SUCCESS"
                            ? "success"
                            : "info", onClose: function () { return handleDeleteRecommendation(rec); }, title: rec.reason }, { children: message }), index));
            })] })));
};
export default ProfileRecommendations;
